import React, { Suspense, lazy, useState } from 'react'
import { Box, Grid, Stack, Switch, Typography } from '@mui/material'
import { type SlotEmailSettings } from '../../../../models/SlotEmailSettings'
import { Controller, type Control } from 'react-hook-form'
import FormInput from '../../../../components/FormElements/FormInput'
import ReactQuill from 'react-quill'
import { grey } from '../../../../colors'

interface EmailSettingsCardProps {
  name: string
  setting: SlotEmailSettings
  control: Control
}

const EmailSettingsCard: React.FC<EmailSettingsCardProps> = ({
  name,
  setting,
  control
}) => {
  return (
    <Stack spacing={6}>
      <Stack spacing={2}>
      <Box display="flex" alignItems="center" gap={2}>
        <Controller
          name={`${name}.enabled`}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Switch checked={value} onChange={onChange} />
          )}
        />
        <Typography variant="p5" sx={{ fontWeight: 'bold' }}>{setting.title}</Typography>
      </Box>
      <Typography variant="p5">{setting.description}</Typography>
    </Stack>
      {
        setting.settingType === 'DAYS_BEFORE' &&
        <FormInput textFieldProps={{
          InputProps: {
            inputProps: { min: 0 }
          }
        }}
        type="number" name={`${name}.daysBefore`} label="Days Before" placeholder="Days Before" control={control} required />
      }
      {
        setting.settingType === 'REMINDER_INTERVAL' &&
        <FormInput textFieldProps={{
          InputProps: {
            inputProps: { min: 0 }
          }
        }}
        type="number" name={`${name}.reminderInterval`} label="Frequency" placeholder="Frequency" control={control} required />
      }

      <Stack spacing={1}>
        <Box sx={{ fontSize: '0.9rem' }}>Custom Message</Box>
        <Controller
          name={`${name}.customMessage`}
          control={control}
          render={({ field }) => (
            <ReactQuill theme="snow"
              style={{ borderRadius: '4px !important' }}
              value={field.value}
              onChange={(e) => {
                field.onChange(e)
              }}
            />
          )} />
        <Box sx={{ fontSize: '0.9rem', color: grey[600] }}>(Optional) Leave blank if no custom message</Box>
      </Stack>
    </Stack>
  )
}

export default EmailSettingsCard
